import { Logger } from "../helpers";

class NewsletterForm {
    constructor( formElement ) {
        // Double check if the form element exists
        if ( !formElement ) {
            Logger.error("Newsletter form element not found.");
            return;
        }

        // Elements
        this.form = formElement;
        this.inputElement = this.form.querySelector("input.newsletter-email-input");
        this.submitButton = this.form.querySelector("button[type='submit']");
        this.successMessage = this.form.querySelector(".newsletter-form-status--success");
        this.errorMessage = this.form.querySelector(".newsletter-form-status--error");

        // Vars
        this.endpoint = window.sanderson_farms.resturl + "sanderson-farms/v2/mailchimp";

        // Add event listener for form submission
        this.form.addEventListener("submit", this.handleSubmit.bind(this));
        // Check if the form has a submit button that is not a type="submit"
        if ( this.submitButton ) this.submitButton.addEventListener("click", this.handleSubmit.bind(this));
    }

    /**
     * Handles form submission.
     * @param {Event} event - The form submission event.
     */
    handleSubmit(event) {
        event.preventDefault(); // Prevent default form submission

        // Get the form data
        const emailInput = this.inputElement.value;

        // Reset the messages
        if ( this.successMessage ) this.successMessage.classList.add("hidden");
        if ( this.errorMessage ) this.errorMessage.classList.add("hidden");

        // Check if the form has an email input, and if it is a valid email
        if ( this.inputElement.value == '' || !this.inputElement.checkValidity() ) {
            if ( this.errorMessage ) this.errorMessage.classList.remove("hidden");
            Logger.error("Email input blank or invalid.");
            return;
        }

        // Track newsletter form submission
        analytics.track(EventTypes.Subscribe, { url: window.location.href });
        
        // Prepare the payload for the API
        const payload = {
            email: emailInput
        };

        // Send the payload to the API
        this.sendEventToApi(payload).then(( data ) => {
            // Handle success (e.g., show a success message)
            Logger.log("Newsletter form submission successful.", data);

            // If the API response is successful, show the success message
            if ( data.success ) {
                // Show success message
                if ( this.successMessage ) this.successMessage.classList.remove("hidden");
                // Set the form, email input, and button to disabled
                this.form.setAttribute("disabled", "disabled");
                if ( this.inputElement ) this.inputElement.setAttribute("disabled", "disabled");
                if ( this.submitButton ) this.submitButton.setAttribute("disabled", "disabled");
            } else {
                Logger.log("Email needs direct submission.", data.direct_form);
                // Open the direct form url in a new window/tab
                window.open(data.direct_form, '_blank').focus();
            }
        }).catch(( error ) => {
            // Handle error (e.g., show an error message)
            if ( this.errorMessage ) this.errorMessage.classList.remove("hidden");
            Logger.error("Error submitting newsletter form:", error);
        });
    }

    sendEventToApi( payload ) {
        return fetch(this.endpoint, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload)
        }).then(( response ) => {
            // Check if the response is ok
            if ( !response.ok ) {
                Logger.error(`Newsletter subscription failed for ${this.endpoint}:`, errorResponse);
                throw new Error(`Newsletter subscription failed for ${this.endpoint}`);
            }
            // Parse the response as JSON
            Logger.log(`Event sent to API successfully: ${this.endpoint}`);
            return response.json();
        }).catch(( error ) => {
            Logger.error(`Error sending event to ${this.endpoint}`, error);
            throw error;
        });
    }
}

export default NewsletterForm;
